import { render, staticRenderFns } from "./setUpCommentator.vue?vue&type=template&id=267d94e2"
import script from "./setUpCommentator.vue?vue&type=script&lang=js"
export * from "./setUpCommentator.vue?vue&type=script&lang=js"
import style0 from "./setUpCommentator.vue?vue&type=style&index=0&id=267d94e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports